import React, { memo } from 'react';
interface ChipContainerProps {
  chipsList: Array<React.ReactNode>;
  containerClass?: string;
  chipClass?: string;
}

const ChipContainer = (props: ChipContainerProps) => {
  const { chipsList, containerClass = '' } = props;
  return (
    <div
      id={`chipcontainer-${chipsList}`}
      className={`min-w-[322px] flex flex-row flex-wrap p-[8px] gap-[4px] visible ${containerClass}`}
    >
      {chipsList}
    </div>
  );
};

export default memo(ChipContainer);
